import { FC } from 'react';
import { CustomModal } from 'components';
import classNames from 'classnames';
import { AtomsIcon, CaretRightIcon, CustomSettingsIcon, FormCloseIcon, LoudSpeakerIcon } from 'assets/icons';

interface RuleType {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface CreateRuleTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (ruleType: string) => void;
}

const RULE_TYPES: RuleType[] = [
  {
    id: 'external_company',
    title: 'External company rule',
    description: 'Set pay conditions based on the external company',
    icon: <AtomsIcon />
  },
  {
    id: 'lead_source',
    title: 'Lead source rule',
    description: 'Set pay conditions based on how the job came in.',
    icon: <LoudSpeakerIcon />
  },
  {
    id: 'custom',
    title: 'Custom rule',
    description: 'Create your own custom payout condition.',
    icon: <CustomSettingsIcon />
  }
];

const CreateRuleTypeModal: FC<CreateRuleTypeModalProps> = ({ isOpen, onClose, onSelect }) => {
  const handleSelect = (selectedType: string) => {
    onSelect(selectedType);
    onClose();
  };

  return (
    <CustomModal
      className="md:w-[607px]"
      open={isOpen}
      closeModal={onClose}
      borderRadius="rounded-lg"
      backgroundColor="bg-white">
      <div className="px-[30px] py-6 text-primaryText">
        <div className="mb-6 flex items-start justify-between">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold">Create a pay rule</h2>
            <div className="text-sbase text-primaryText">Define how team members earn commissions.</div>
          </div>
          <FormCloseIcon className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </div>

        <div className="mb-6">
          {RULE_TYPES.map(ruleType => (
            <label
              key={ruleType.id}
              className={classNames(
                `flex w-full cursor-pointer items-center justify-between 
              px-3 py-6 border-b border-secondaryBtn last:border-b-0`
              )}
              onClick={() => handleSelect(ruleType.id)}>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-secondaryBtn">
                  {ruleType.icon}
                </div>
                <div className="flex flex-col">
                  <span className="mb-1 text-17px font-semibold">{ruleType.title}</span>
                  <span className="text-sbase text-accentText">{ruleType.description}</span>
                </div>
              </div>

              <CaretRightIcon />
            </label>
          ))}
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateRuleTypeModal;
